import { CtaCenterAlign } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'
import { createStoryblokMultilink } from '../../../../../__mocks__/storyblok/createStoryblokMultilink'

/**
 * Creates a mock CtaCenterAlign
 * @param overrides - Partial fields to override defaults
 * @returns Complete CtaCenterAlign mock
 */
export function createCtaCenterAlign(
  overrides: Partial<CtaCenterAlign> = {}
): CtaCenterAlign {
  return {
    _uid: 'c2ebffe0-9fcb-42d0-b332-9c576d8d3ba2',
    link: createStoryblokMultilink({
      id: 'e8c991b7-c7f9-49dd-af80-6bb3c53967e1',
      linktype: 'story',
      cached_url: 'sunpoint/jobs/',
    }),
    image: createStoryblokAsset({
      id: 10343902,
      alt: 'Suns',
      title: 'Suns',
      filename:
        'https://a.storyblok.com/f/235453/1216x303/4032f39ca5/suns_background.png',
      src: 'https://a.storyblok.com/f/235453/1216x303/4032f39ca5/suns_background.png',
      width: 1216,
      height: 303,
      aspect_ratio: 4.01,
      content_type: 'image/png',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    button: 'sdasdadssdd',
    content: 'sdadadads\ndssdsdsd\nsdadssd',
    headline: 'asdsddddddsad',
    component: 'cta-center-align',
    calltoaction: 'Jetzt oder nie',
    buttonStyle: 'primary',
    _editable:
      '<!--#storyblok#{"name": "cta-center-align", "space": "235453", "uid": "c2ebffe0-9fcb-42d0-b332-9c576d8d3ba2", "id": "322787899"}-->',
    ...overrides,
  }
}
